import { render } from "./AccountSettings.vue?vue&type=template&id=795158a3&scoped=true&ts=true"
import script from "./AccountSettings.vue?vue&type=script&lang=ts"
export * from "./AccountSettings.vue?vue&type=script&lang=ts"

import "./AccountSettings.vue?vue&type=style&index=0&id=795158a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795158a3"]])

export default __exports__